<template>
    <div>
        <b-navbar v-b-scrollspy:nav-scroller ref="navbar" toggleable="md" variant="dark">
            <b-navbar-brand href="#home"><img src="../assets/images/radix-logo.png"></b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item href="#home">Home</b-nav-item>
                    <b-nav-item href="#about">About</b-nav-item>
                <!-- <b-nav-item-dropdown href="#about" text="About Us">
                    <b-dropdown-item href="#values">Vision and Missions</b-dropdown-item>
                    <b-dropdown-item>What We Do</b-dropdown-item>
                </b-nav-item-dropdown> -->
                <b-nav-item href="#">Products</b-nav-item>
                <b-nav-item href="#">Services</b-nav-item>
                <b-nav-item href="#collaborators">Collaborators</b-nav-item>
                <b-nav-item href="#contact">Contact</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    methods: {
        stickNavbar(){
            if (window.pageYOffset >= sticky) {
                this.$refs.navbar.classList.add("sticky")
            } else {
                this.$refs.navbar.classList.remove("sticky");
            }
        }
    },
    mounted(){
        //window.onscroll = function() {this.stickNavbar()};
    }
}
</script>

<style scoped>
/* .navbar {
    padding: 0.8rem 0;
    width: 100%;
    color: white;
    background-color: #052d3b;
} */

.navbar {
    height: 7rem;
    font-size: 1.2rem;
}

.navbar a {
    color: rgb(255,255,255);
}

.bg-dark {
    background-color: #052d3b !important;
}

.sticky {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #052d3b;
}

img {
    max-height: 50px;
    margin-left: 1rem;
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(255,255,255, 1);
    background-color: #052d3b;
}

.nav-item .nav-link {
    background-color: #052d3b;
}

</style>